import "angular:locale/data:en-GB";
import "zone.js";
import "@angular/localize/init";(globalThis.$localize ??= {}).locale = "en-GB";
